module.exports = __webpack_public_path__ + "static/media/about-background@3x.f65d9181.png";